export const color = '#EA3038';
export const dark = '#313131';
export const lightblue = '#66b1ff';
export const blue = '#409eff';
export const green = '#67c23a';
export const yellow = '#e6a23c';
